__turbopack_context__.v({
  "content": "TermsModal-module-scss-module__jieLuW__content",
  "fade-in": "TermsModal-module-scss-module__jieLuW__fade-in",
  "frame": "TermsModal-module-scss-module__jieLuW__frame",
  "radialBg": "TermsModal-module-scss-module__jieLuW__radialBg",
  "root": "TermsModal-module-scss-module__jieLuW__root",
});
